/*
 * @Author: your name
 * @Date: 2021-01-07 17:46:31
 * @LastEditTime: 2021-03-12 14:31:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\store\getters.js
 */
import {CURRENT_AREA_ID, CURRENT_MAP, GARDEN_DATA} from "./modules/app/type";

export default {
    opened: (state) => state.app.slider.opened,
    token: (state) => state.app.token,
    djiCloudToken: (state) => state.app.djiCloudToken,
    uname: (state) => state.app.uname,
    userinfo: (state) => {
        let userInfo = sessionStorage.getItem("userinfo");
        return JSON.parse(userInfo)
    },
    currentMap : (state) => {
        let currentMap = state.app.currentMap
        return currentMap;
    },
    userLocation: (state) => state.app.userLocation,
    warningInfo: (state) => state.weather.warningInfo,
    miniUserId: (state) => state.app.miniUserId,
    curentGarden: (state) => state.weather.curentGarden,
    flyObject: (state) => state.fly.flyObject,
    flyArea: (state) => state.fly.flyArea,
    actionNum: (state) => state.app.actionNum,
    tips: (state) => state.app.tips,
    isExampleGarden: (state) => state.app.isExampleGarden,
};
